import Swal from "sweetalert2";
import { ANALYTICS_COOKIE_NAME, getCookie } from "helpers/HotjarContext";
import {
  ValidateOzonerResponse,
  ValidateOzonerRequest,
  ValidateOzonerPhoneResponse,
} from "../interfaces/auth-client.interface";
import { PandaboardApiInstance } from "../../../helpers/api";

export const fetchRefreshToken = (refreshToken: string) =>
  PandaboardApiInstance.post(
    "/auth-client/refresh",
    { refresh_token: refreshToken },
    {
      headers: { refreshRequest: true },
    }
  );

export const fetchValidateOzoner = async (data: ValidateOzonerRequest) =>{

  const id = getCookie(ANALYTICS_COOKIE_NAME);
  return PandaboardApiInstance.post<ValidateOzonerResponse>("auth-client/validate-ozoner", {...data, analyticsIds: [id]})
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
};

export const fetchValidateCurp = async (curp: string) =>
  fetchValidateOzoner({ curp })
    .then(({ exist, email, financialFormStatus }) => {
      if (exist && financialFormStatus) {
        Swal.fire({
          text: `Este CURP ya se encuentra vinculado a una solicitud con el correo ${email}, ingresa un CURP valido.`,
          title: "¡TU CURP YA ESTÁ REGISTRADO!",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "bg_primary_300 w_90_per",
            title: "text_neutral_800",
            container: "text_neutral_700",
          },
        });
      }
      return !(exist && financialFormStatus);
    })
    .catch((err: any) => {
      if (err.response && err.response.status === 400) {
        Swal.fire({
          text: "¡CURP invalido!",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
      throw err.response.data;
    });

export const fetchValidatePhone = async (dialCode: string, phone: string) =>
  PandaboardApiInstance.post<ValidateOzonerPhoneResponse>("auth-client/validate-phone", { dialCode, phone })
    .then((res) => {
      const { exists } = res.data;
      if (exists) {
        Swal.fire({
          text: "El numero que escribiste ya está en otra solicitud. Usa otro o dirígete a la sección Mi Cuenta.",
          title: "¡Ups! Número ya registrado",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "bg_primary_300 w_90_per",
            title: "text_neutral_800",
            container: "text_neutral_700",
          },
        });
      }
      return exists;
    })
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchLogin = async (curp: string, password: string) =>
{
  const id = getCookie(ANALYTICS_COOKIE_NAME);

  return PandaboardApiInstance
    .post("auth-client/login", { curp, password, analyticsIds: [id]})
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });
};

export const fetchLogout = async () =>
  PandaboardApiInstance
    .get("auth-client/logout", { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchOtpPassword = async (curp: string) =>
  PandaboardApiInstance
    .post(`auth-client/otp/${curp}`)
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchOtpValidation = async (curp: string, otp: string) =>
{
  const id = getCookie(ANALYTICS_COOKIE_NAME);

  return  PandaboardApiInstance
      .post("auth-client/otp/validate", { curp, otp, analyticsIds: [id]})
      .then((res) => res.data)
      .catch((err: any) => {
        throw err.response.data;
      });
};

export const fetchChangePassword = async (password: string, confirmPassword: string) =>
  PandaboardApiInstance
    .post("auth-client/reset-password", { password, confirmPassword}, { requireAuth: true })
    .then((res) => res.data)
    .catch((err: any) => {
      throw err.response.data;
    });

export const fetchGetTempToken = async (email: string) =>
{
  const id = getCookie(ANALYTICS_COOKIE_NAME);

  return  PandaboardApiInstance
      .post("auth-client/temp-token", { email, analyticsIds: [id]}, { requireAuth: true })
      .then((res) => res.data)
      .catch((err: any) => {
        throw err.response.data;
      });
};